import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { createMRTColumnHelper } from "material-react-table";
import Chip from "@mui/material/Chip";
import { Box, Tooltip, IconButton } from "@mui/material";
import { Icon } from "@iconify/react";
import { baseUrl } from "../../../helper/urls";
import AdminCustomTable from "../../../components/custom_table/AdminCustomTable";
import { useSelector } from "react-redux";

const MySwal = withReactContent(Swal);

const Invoice = ({ status }) => {
  const { token } = useSelector((state) => state.auth);

  const [invoice, setInvoice] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchInvoiceList = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/booking_req/invoice/list`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response, ">>>>>>>>response");
      setInvoice(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching booking requests:", error);
      setError("Failed to fetch booking requests");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvoiceList();
  }, []);

  const statusMap = {
    0: "Unpaid",
    1: "Paid",
  };

  const statusMapType = {
    0: "warning",
    1: "success",
  };

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("Actions", {
      header: "Download Invoice",
      Cell: ({ cell }) => {
        const row = cell.row.original;
        const { invoice_url } = row;

        return (
          <Box>
            <a
              href={`${baseUrl}${invoice_url}`}
              target="_blank"
              rel="noopener noreferrer"
              download
              className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
              style={{ cursor: "pointer" }}
              title="Download Invoice"
            >
              <Icon icon="lucide:download" />
            </a>
          </Box>
        );
      },
    }),
    columnHelper.accessor((row) => `DDR000${row.id}`, {
      id: "id",
      header: "Request ID",
      size: 30,
    }),
    columnHelper.accessor("paymentId", {
      header: "Payment ID",
      Cell: (cell) => {
        const link = cell.row.original?.paymentId;

        const copyToClipboard = () => {
          if (link) {
            navigator.clipboard.writeText(link);
          }
        };

        return link ? (
          <Tooltip title={link}>
            <IconButton onClick={copyToClipboard} size="small" color="primary">
              <Icon icon="lucide:copy" />
            </IconButton>
          </Tooltip>
        ) : (
          "-"
        );
      },
    }),
    columnHelper.accessor("service_type", {
      header: "Service Type",
      Cell: (cell) => cell.row.original?.service_type || "-",
    }),
    columnHelper.accessor("total_amount", {
      header: "Amount ($)",
      Cell: (cell) => cell.row.original?.total_amount || "-",
    }),
    // columnHelper.accessor("status", {
    //   header: "Status",
    //   Cell: (cell) => {
    //     const status = cell.row.original?.status;
    //     return (
    //       <Chip
    //         label={statusMap[status]}
    //         color={statusMapType[status]}
    //         variant="outlined"
    //       />
    //     );
    //   },
    // }),

    columnHelper.accessor("updated_at", {
      header: "Date",
      size: 30,
      Cell: (cell) => cell.row.original?.updated_at?.split("T")[0] || "N/A",
    }),
  ];

  return (
    <AdminCustomTable columns={columns} data={invoice} loading={loading} />
  );
};

export default Invoice;
